import { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import { Layout, Button, Menu, Tabs, message } from "antd";
import {
  HomeOutlined,
  AppstoreOutlined,
  PlusOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import mainStyles from "../../styles/Main.module.css";
import { getBricksForOrganization } from "../../utils";
import OrganizationBrickCollections from "./OrganizationBrickCollections";
import CreateCollectionModal from "./CreateCollectionModal";
import AccountMenu from "../../fragments/AccountMenu/AccountMenu";
import Members from "./Members";
import { SessionContext } from "../../session/SessionContext";
import { isOperator } from "../../session/access";

const { Header, Sider, Content } = Layout;

interface State {
  brickCollections: any[] | null;
  createCollectionModal: boolean;
}

class Dashboard extends Component<any, State> {
  static contextType = SessionContext;
  declare context: React.ContextType<typeof SessionContext>;

  state: State = {
    brickCollections: null,
    createCollectionModal: false,
  };

  componentDidMount() {
    this.fetchBricks();
  }

  fetchBricks = async () => {
    try {
      const brickCollections = await getBricksForOrganization(
        this.props.match.params.organizationId
      );
      this.setState({ brickCollections });
    } catch (e) {
      message.error((e as Error).message);
      this.setState({ brickCollections: [] });
    }
  };

  render() {
    const operator = isOperator(this.context.user);
    return (
      <Layout className={mainStyles.main}>
        <Sider className={mainStyles.mainSider} width={200}>
          <div className={mainStyles.siderLogo}>Brixture</div>
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={["collections"]}
            items={[
              ...(operator
                ? [
                    {
                      key: "home",
                      icon: <HomeOutlined />,
                      label: "Organizations",
                      onClick: () => this.props.history.push("/"),
                    },
                  ]
                : []),
              {
                key: "collections",
                icon: <AppstoreOutlined />,
                label: "Collections",
              },
            ]}
          />
        </Sider>
        <Layout>
          <Header className={mainStyles.mainHeader}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {operator && (
                <Button
                  type="text"
                  icon={<ArrowLeftOutlined />}
                  onClick={() => this.props.history.push("/")}
                />
              )}
              <span className={mainStyles.headerTitle}>Brick Collections</span>
            </div>
            <div className={mainStyles.headerActions}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => this.setState({ createCollectionModal: true })}
              >
                Nieuwe Collectie
              </Button>
              <AccountMenu />
            </div>
          </Header>
          <Content className={mainStyles.container}>
            {operator ? (
              <Tabs
                items={[
                  {
                    key: "collections",
                    label: "Collections",
                    children: (
                      <OrganizationBrickCollections
                        brickCollections={this.state.brickCollections}
                      />
                    ),
                  },
                  { key: "members", label: "Members", children: <Members /> },
                ]}
              />
            ) : (
              <OrganizationBrickCollections brickCollections={this.state.brickCollections} />
            )}
          </Content>
        </Layout>
        <CreateCollectionModal
          open={this.state.createCollectionModal}
          onClose={() => {
            this.fetchBricks();
            this.setState({ createCollectionModal: false });
          }}
        />
      </Layout>
    );
  }
}

export default withRouter(Dashboard);
